import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Dropdown from 'react-bootstrap/Dropdown';

import imageURLs from '../../sharedFiles/ImagesURLs';

import HeaderStore from './HeaderStore';
import NotificationComponent from '../tooltips/NotificationComponent';
//import NotificationComponent from '../notificationPopup/NotificationComponent';
import HelpPopupTooltip  from '../tooltips/HelpPopupTooltip';
import HelpTourComponent from '../helpTour/HelpTourComponent';
import ConfirmationComponent from '../../sharedComponents/confirmationPopup/ConfirmationComponent';
import TourGuide from '../../sharedComponents/TourGuide';
import ModalVideo from 'react-modal-video'
import ReactTooltip from 'react-tooltip'
import HelpTourImplementStart from '../helpTour/HelpTourImplementStart';

const ClickOutHandler = require('react-onclickout');

const HeaderComponent = observer(class HeaderComponent extends Component {

	constructor(props) {
		super(props);
		this.headerStore = new HeaderStore();
		//check account disabled
		this.headerStore.isAccountDisabled(this.props.appstore);
		this.headerStore.showPrivacyPolicy(this.props.appstore); 

		this.state = { currentCount: 10,
			// tourStep:1 
		}
	}

	componentWillMount() {

	}
	componentDidCatch() {
	
	}
 
	getNotificationinInterval() {
		this.headerStore.getNotification(this.props.appstore);
	}

	componentDidMount() {
		//this.props.appstore.soundon_off=localStorage.getItem("soundOnorOff");
		this.headerStore.getNotification(this.props.appstore);
		setInterval(this.getNotificationinInterval.bind(this), 300000);
		//show help popup
	
		if(this.props.appstore.userInfo.accountsmodel.show_welcome == 1 && this.props.appstore.isAdmin){
			let tooltip = document.querySelectorAll(`[data-tip][data-for="helpTooltipClick"]`)[0]
			ReactTooltip.show(tooltip)
			//this.headerStore.showWelcomeCount = 2;
		}
	}

	tourButton() {
		if (this.headerStore.stepNumber == 0)
			return "Start";
		else if (this.headerStore.stepNumber == 18)
			return "Got it";
		else
			return "Next";
	}


	setStatus = (status) => {
		if (status === -1)
			this.headerStore.logout = true;
		else
			this.headerStore.setDropDownValue(status,this.props.appstore);
	}

	confirmLogout = () => {
		this.props.appstore.logout()
	}
	clickouthandler = () =>{
		if(!this.headerStore.belliconclicked){
			this.tooltip.tooltipRef = null; 
			ReactTooltip.hide();
			//this.headerStore.notification_popup=false;
		}
	}
	notificationcountcheck = (notificationcount)=>{
		const notification_count=notificationcount;
		if(notification_count>9){
			//let notify = notification_count.toString();
			let count=9+"+"; 
			return count;
		}else{
			return notification_count;
		}
	}

	render() {
		var self = this;
		//this.headerStore.initialrenderCount=this.headerStore.initialrenderCount+1
		const { appstore } = this.props;

		var dropDownData = this.headerStore.headerDropDownData.map(function (item, index) {
			return (
				<Dropdown.Item as="p" key={index} className="cursor-pointer" onClick={() => self.setStatus(item.status)}>{appstore.getLanguageTrans(item.label)}</Dropdown.Item>
			)
		})
		var help_dropDownData = this.headerStore.helpDropDownData.map(function (value, index) {
			
			return (
				<Dropdown.Item as="h" key={index} className="cursor-pointer" onClick={() => {self.headerStore.starttour(value.status,appstore);}}>{appstore.getLanguageTrans(value.label)}</Dropdown.Item>
			)
		})

		return (
			<div className="row header w-100" id="header">
				<div className={appstore.userInfo.accountsmodel.private_label==0 ? "col-6 col-sm-5 col-md-5 col-lg-3 align-self-center":"col-6 col-sm-5 col-md-5 col-lg-4 align-self-center"}>
					<div className="row align-items-center h-100">
						<div className="col-2 col-md-2 d-lg-none">
							<button type="button" id="sidebarCollapse" className="navbar-btn active" onClick={() => appstore.toggleMenu()}>
								<span></span>
								<span></span>
								<span></span>
							</button>
						</div>
						<div className={appstore.userInfo.accountsmodel.private_label==1 ? "col-8 col-lg-8 logo_wrapper":"col-8 col-md-5 col-lg-4 logo_wrapper"}>
						{appstore.userInfo.accountsmodel.private_label==1 &&
							<p className="custome_company_name" style={{color:appstore.selectedColor.color}} onClick={() => appstore.navigate('/home')}>{appstore.userInfo.accountsmodel.private_label_title}</p>
						}
						{appstore.userInfo.accountsmodel.private_label==0 &&
						 <img src={imageURLs.logoIcon} alt="Helponclick Logo" className="logo-img img-fluid" onClick={() => appstore.navigate('/home')} />
						} 
						</div>
						{appstore.userInfo.accountsmodel.private_label==0 &&
						<p className="text-left col-xs-6 col-md-5 col-lg-8 divider d-none d-sm-block">{appstore.getLanguageTrans("Live Chat Dashboard")}</p>
						}
						</div>
				</div>
				{appstore.userInfo.accountsmodel.private_label==0 &&
				<div className="col-2 col-sm-2 col-md-2 col-lg-3 pr-0">
				<p className="text-left expire_account d-none d-sm-block">{this.headerStore.accountexpires}</p>
				</div>
				}
				<div className={appstore.userInfo.accountsmodel.private_label==0 ? "col-4 col-sm-5 col-md-5 col-lg-6 pr-0":
								"col-6 col-sm-7 col-md-7 col-lg-8 pr-0"}>
					<div className="menu-right pull-right h-100">
						<div className="row align-items-center h-100">

							{/* <svg id="SVGDoc" width="18" height="21" viewBox="0 0 18 21"><defs><clipPath id="ClipPath1036"><path d="M12.00003,20c0,0.37673 -0.66551,0.84009 -0.99998,1.00008c-0.12932,0.06203 0.13763,0 0,0c-0.21805,0 -0.88181,0.06598 -1.05629,-0.08109l-4.9437,-5.91903v0h-4.00009c-0.52658,0 -1.00006,0.0818 -1.00006,-0.45484v-7.87139c0,-0.53672 0.47348,-0.67378 1.00006,-0.67378h4.00009v0l4.94392,-5.7c0.28481,-0.24055 0.72174,-0.46099 1.05606,-0.29994c0.33424,0.15981 0.99998,0.62326 0.99998,0.9999v19.0001v0z" fill="#ffffff"></path></clipPath><clipPath id="ClipPath1060"><path d="M12.00003,20c0,0.37673 -0.66551,0.84009 -0.99998,1.00008c-0.12932,0.06203 0.13763,0 0,0c-0.21805,0 -0.88181,0.06598 -1.05629,-0.08109l-4.9437,-5.91903v0h-4.00009c-0.52658,0 -1.00006,0.0818 -1.00006,-0.45484v-7.87139c0,-0.53672 0.47348,-0.67378 1.00006,-0.67378h4.00009v0l4.94392,-5.7c0.28481,-0.24055 0.72174,-0.46099 1.05606,-0.29994c0.33424,0.15981 0.99998,0.62326 0.99998,0.9999v19.0001v0z" fill="#ffffff"></path></clipPath></defs><g><g><title>Forma 1</title><path d="M12.00003,20c0,0.37673 -0.66551,0.84009 -0.99998,1.00008c-0.12932,0.06203 0.13763,0 0,0c-0.21805,0 -0.88181,0.06598 -1.05629,-0.08109l-4.9437,-5.91903v0h-4.00009c-0.52658,0 -1.00006,0.0818 -1.00006,-0.45484v-7.87139c0,-0.53672 0.47348,-0.67378 1.00006,-0.67378h4.00009v0l4.94392,-5.7c0.28481,-0.24055 0.72174,-0.46099 1.05606,-0.29994c0.33424,0.15981 0.99998,0.62326 0.99998,0.9999v19.0001v0z" fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#3ba8c5" stroke-miterlimit="50" stroke-width="4" clip-path="url(&quot;#ClipPath1036&quot;)"></path></g><g><title>Forma 1</title><path d="M15.17104,15.65212c-0.02304,0.00167 -0.04562,0.00264 -0.06844,0.00264c-0.25208,0 -0.495,-0.10139 -0.67444,-0.28448l-0.12772,-0.13064c-0.33455,-0.34018 -0.37354,-0.87901 -0.09186,-1.26585c0.71388,-0.98084 1.09108,-2.14416 1.09108,-3.36423c0,-1.31232 -0.42816,-2.5432 -1.23802,-3.55962c-0.3083,-0.38648 -0.27992,-0.94763 0.06569,-1.2995l0.12726,-0.12994c0.19051,-0.19408 0.44579,-0.29986 0.72227,-0.28308c0.26909,0.01371 0.52025,0.14286 0.69069,0.35538c1.12335,1.40053 1.717,3.1011 1.717,4.91702c0,1.69125 -0.52498,3.30124 -1.51794,4.65512c-0.16586,0.22562 -0.41954,0.36733 -0.69557,0.38719z" fill="#3ba8c5" fill-opacity="1"></path></g><g><title>sound</title><g><title>Forma 1</title><path d="M15.86661,15.26493c0.99297,-1.35388 1.51794,-2.96386 1.51794,-4.65512c0,-1.81592 -0.59364,-3.51649 -1.717,-4.91702c-0.17044,-0.21253 -0.4216,-0.34168 -0.69069,-0.35538c-0.27649,-0.01678 -0.53177,0.089 -0.72227,0.28308l-0.12726,0.12994c-0.34561,0.35187 -0.37399,0.91301 -0.06569,1.2995c0.80986,1.01642 1.23802,2.2473 1.23802,3.55962c0,1.22007 -0.3772,2.38339 -1.09108,3.36423c-0.28168,0.38684 -0.24269,0.92566 0.09186,1.26585l0.12772,0.13064c0.17944,0.18309 0.42236,0.28448 0.67444,0.28448c0.02281,0 0.04539,-0.00097 0.06844,-0.00264c0.27603,-0.01986 0.52971,-0.16157 0.69557,-0.38719zM21.99965,10.60955c0,-3.05691 -1.09627,-5.99837 -3.08632,-8.28169c-0.17471,-0.20014 -0.42305,-0.31831 -0.6855,-0.32595c-0.27672,-0.00896 -0.51758,0.09576 -0.70312,0.28562l-0.12505,0.12774c-0.35522,0.36329 -0.37193,0.94534 -0.03815,1.32998c1.64658,1.89411 2.55348,4.33198 2.55348,6.86429c0,2.43452 -0.84709,4.80184 -2.38533,6.66555c-0.31822,0.38604 -0.29457,0.95615 0.05554,1.31259l0.12527,0.12766c0.17944,0.18266 0.42183,0.28448 0.67444,0.28448c0.0135,0 0.02686,-0.00044 0.0399,-0.00088c0.26703,-0.01151 0.51643,-0.13618 0.68893,-0.34387c1.86142,-2.24669 2.88635,-5.10407 2.88589,-8.04553z" fill="#3ba8c5" fill-opacity="1"></path></g><g><title>Forma 1</title><path d="M15.17104,15.65212c-0.02304,0.00167 -0.04562,0.00264 -0.06844,0.00264c-0.25208,0 -0.495,-0.10139 -0.67444,-0.28448l-0.12772,-0.13064c-0.33455,-0.34018 -0.37354,-0.87901 -0.09186,-1.26585c0.71388,-0.98084 1.09108,-2.14416 1.09108,-3.36423c0,-1.31232 -0.42816,-2.5432 -1.23802,-3.55962c-0.3083,-0.38648 -0.27992,-0.94763 0.06569,-1.2995l0.12726,-0.12994c0.19051,-0.19408 0.44579,-0.29986 0.72227,-0.28308c0.26909,0.01371 0.52025,0.14286 0.69069,0.35538c1.12335,1.40053 1.717,3.1011 1.717,4.91702c0,1.69125 -0.52498,3.30124 -1.51794,4.65512c-0.16586,0.22562 -0.41954,0.36733 -0.69557,0.38719z" fill="#3ba8c5" fill-opacity="1"></path></g><g><title>Forma 1</title><path d="M12.00003,20c0,0.37673 -0.66551,0.84009 -0.99998,1.00008c-0.12932,0.06203 0.13763,0 0,0c-0.21805,0 -0.88181,0.06598 -1.05629,-0.08109l-4.9437,-5.91903v0h-4.00009c-0.52658,0 -1.00006,0.0818 -1.00006,-0.45484v-7.87139c0,-0.53672 0.47348,-0.67378 1.00006,-0.67378h4.00009v0l4.94392,-5.7c0.28481,-0.24055 0.72174,-0.46099 1.05606,-0.29994c0.33424,0.15981 0.99998,0.62326 0.99998,0.9999v19.0001v0z" fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#3ba8c5" stroke-miterlimit="50" stroke-width="4" clip-path="url(&quot;#ClipPath1060&quot;)"></path></g></g></g></svg> */}
							
							{appstore.soundon_off &&
							  <img  onClick={() => {appstore.soundon_off=false; localStorage.setItem("soundOnorOff",0)}} style={{marginRight: appstore.isAdmin ? 28 : 0}} src={"#3ba8c5" == appstore.selectedColor.color ? imageURLs.mute_steelblue : "#4cb6ac" == appstore.selectedColor.color ? imageURLs.mute_sea_green : "#ec407a" == appstore.selectedColor.color ?  imageURLs.mute_pink : "#6e4c42" == appstore.selectedColor.color ?imageURLs.mute_brown : "#234e91" == appstore.selectedColor.color ?imageURLs.mute_navy_blue : "#e89712" == appstore.selectedColor.color ?imageURLs.mute_yellow : "#b968c7" ==appstore.selectedColor.color ?imageURLs.mute_voilet : 
									"#039be6" == appstore.selectedColor.color ? imageURLs.mute_blue : "#00887a" == appstore.selectedColor.color ? imageURLs.mute_darkgreen : "#4b8f4e" == appstore.selectedColor.color ? imageURLs.mute_green : "#5f7c8c" == appstore.selectedColor.color ? imageURLs.mute_grey : "#64a9e0"== appstore.selectedColor.color ? imageURLs.mute_deep_sky_blue : imageURLs.mute_steel_blue} alt="sound" className="img-fluid headerspeakericon"/>
							}
							{!appstore.soundon_off &&
							<img  onClick={() => {appstore.soundon_off=true ; localStorage.setItem("soundOnorOff",1)}} style={{marginRight: appstore.isAdmin ? 28 : 0}} src={"#3ba8c5" == appstore.selectedColor.color ? imageURLs.sound_steelblue : "#4cb6ac" == appstore.selectedColor.color ? imageURLs.sound_sea_green : "#ec407a" == appstore.selectedColor.color ?  imageURLs.sound_pink : "#6e4c42" == appstore.selectedColor.color ?imageURLs.sound_brown : "#234e91" == appstore.selectedColor.color ?imageURLs.sound_navy_blue : "#e89712" == appstore.selectedColor.color ?imageURLs.sound_yellow : "#b968c7" ==appstore.selectedColor.color ?imageURLs.sound_voilet : 
									"#039be6" == appstore.selectedColor.color ? imageURLs.sound_blue : "#00887a" == appstore.selectedColor.color ? imageURLs.sound_darkgreen : "#4b8f4e" == appstore.selectedColor.color ? imageURLs.sound_green : "#5f7c8c" == appstore.selectedColor.color ? imageURLs.sound_grey : "#64a9e0"== appstore.selectedColor.color ? imageURLs.sound_sky_blue : imageURLs.sound_steel_blue} alt="sound" className="img-fluid headerspeakericon"/>
							}
									{appstore.isAdmin && 
						   <div className="help_dropdown"   data-tip data-for={this.headerStore.showWelcomeCount ==1 ? 'helpTooltipClick':''} onClick={()=> {this.headerStore.notification_popup=false;this.headerStore.showWelcomeCount =0}}>
								<Dropdown>
									<Dropdown.Toggle as="H" bsPrefix="noCaret" id="dropdown-basic" className="cursor-pointer">

										<img src={"#3ba8c5" == appstore.selectedColor.color ? imageURLs.Help_icon_blue : "#4cb6ac" == appstore.selectedColor.color ? imageURLs.Help_icon_SeaGreen : "#ec407a" == appstore.selectedColor.color ?  imageURLs.Help_icon_pink2 : "#6e4c42" == appstore.selectedColor.color ?imageURLs.Help_icon_brown : "#234e91" == appstore.selectedColor.color ?imageURLs.Help_icon_Navyblue : "#e89712" == appstore.selectedColor.color ?imageURLs.Help_icon_Yellow : "#b968c7" ==appstore.selectedColor.color ?imageURLs.Help_icon_voilet : 
									"#039be6" == appstore.selectedColor.color ? imageURLs.Help_icon_blue2 : "#00887a" == appstore.selectedColor.color ? imageURLs.Help_icon_Darkgreen : "#4b8f4e" == appstore.selectedColor.color ? imageURLs.Help_icon_green : "#5f7c8c" == appstore.selectedColor.color ? imageURLs.Help_icon_Grey : "#64a9e0"== appstore.selectedColor.color ? imageURLs.Help_icon_deep_sky_blue : imageURLs.Help_icon_blue} alt="faq" className="img-fluid faq help_Icon help_Icon_end" />
									</Dropdown.Toggle>

									<Dropdown.Menu x-placement="bottom-centre">
										{help_dropDownData}
									</Dropdown.Menu>
								</Dropdown>
							</div>
	 					  }
							<div className="headerbellicon" style={{marginTop:7,paddingRight: ((appstore.isOwner && appstore.userInfo.accountsmodel.display_buy_now==1) || !appstore.isAdmin) ? 0 : 60}}>
							<svg id="SVGDoc" width="8" height="11" viewBox="0 0 8 11"><g><g><title>?</title><g transform="matrix(1,0,0,1,0,0)"><text dominantBaseline="text-before-edge" style={{ fill: appstore.selectedColor.value, fillOpacity: 1, fontSize: '15px', fontFamily: 'Roboto-Black', fontWeight: 'normal', fontStyle: 'none', textTransform: 'uppercase', lineHeight: '50px' }}>
									{/*<tspan style={{fontKerning: 'normal'}}>?</tspan>*/}
									<tspan style={{ fontKerning: 'normal' }}></tspan>
								</text></g></g></g></svg>
								<div id="notificationIcon" className="notification cursor-pointer"  data-offset="{'left': 98}"  data-tip data-for='notificationClickme' data-event='click' onMouseOver={(event) => {this.headerStore.belliconclicked=true;}} onMouseOut={(event) => {this.headerStore.belliconclicked=false;}} onClick={() => {this.headerStore.getNotification(this.props.appstore,true);this.headerStore.showWelcomeCount =0;}}>
								<img src={"#3ba8c5" == appstore.selectedColor.color ? imageURLs.bell_steel_blue : "#4cb6ac" == appstore.selectedColor.color ? imageURLs.bell_light_sea_green : "#ec407a" == appstore.selectedColor.color ?imageURLs.bell_pink : "#6e4c42" == appstore.selectedColor.color ?imageURLs.bell_brown : "#234e91" == appstore.selectedColor.color ?imageURLs.bell_Navy_blue : "#e89712" == appstore.selectedColor.color ?imageURLs.bell_yellow : "#b968c7" ==appstore.selectedColor.color ?imageURLs.bell_voilet : 
									"#039be6" == appstore.selectedColor.color ? imageURLs.bell_blue : "#00887a" == appstore.selectedColor.color ? imageURLs.bell_dark_green : "#4b8f4e" == appstore.selectedColor.color ? imageURLs.bell_green : "#5f7c8c" == appstore.selectedColor.color ? imageURLs.bell_grey : "#64a9e0"== appstore.selectedColor.color ? imageURLs.bell_deep_sky_blue : imageURLs.bell_steel_blue} alt="notification" className="img-fluid" />
									{this.headerStore.notificationCount>0 && <div className="notification_ellipse"><p><b>{this.notificationcountcheck(this.headerStore.notificationCount)}</b></p></div>}
								</div>
							</div>
							 <div className="profileStatus" >
								<img src={(appstore.userInfo.usersmodel.image != '' && appstore.userInfo.usersmodel.image != undefined) ? this.props.appstore.resourceurl + this.props.appstore.userInfo.accountsmodel.account_uid + "/" + appstore.userInfo.usersmodel.image :
								 "#3ba8c5" == appstore.selectedColor.color ? imageURLs.avatar_steelblue : "#4cb6ac" == appstore.selectedColor.color ? imageURLs.avatar_seagreen : "#ec407a" == appstore.selectedColor.color ?imageURLs.avatar_pink : "#6e4c42" == appstore.selectedColor.color ?imageURLs.avatar_brown : "#234e91" == appstore.selectedColor.color ?imageURLs.avatar_navyblue : "#e89712" == appstore.selectedColor.color ?imageURLs.avatar_yellow : "#b968c7" ==appstore.selectedColor.color ?imageURLs.avatar_voilet : 
								 "#039be6" == appstore.selectedColor.color ? imageURLs.avatar_blue : "#00887a" == appstore.selectedColor.color ? imageURLs.avatar_darkgreen : "#4b8f4e" == appstore.selectedColor.color ? imageURLs.avatar_green : "#5f7c8c" == appstore.selectedColor.color ? imageURLs.avatar_grey : "#64a9e0"== appstore.selectedColor.color ? imageURLs.avatar_skyblue : imageURLs.avatar_steelblue} alt="avatar" className="avatar bg_circle img-fluid" />
								{/* {this.headerStore.userStatus !== 1 && */}
								{appstore.userlivestatus === "offline" &&
									<div className="red_circle"></div>
								}
								{appstore.userlivestatus === "online" &&
									<div className="green_circle"></div>
								}
								<div className="status">
									<p className="d-none d-sm-block ">{appstore.userInfo.hasOwnProperty('usersmodel') ? appstore.userInfo.usersmodel.real_name : "unknown"}</p>
									<div className="float">
										<Dropdown>
											{/* <Dropdown.Toggle as="p" bsPrefix="noCaret" id="dropdown-basic" className={this.headerStore.userStatus === 1 ? "statusDisplay text-active cursor-pointer" : "statusDisplay cursor-pointer"}> */}
											<Dropdown.Toggle as="p" bsPrefix="noCaret" id="dropdown-basic" className={appstore.userlivestatus === "online" ? "statusDisplay text-active cursor-pointer" : "statusDisplay cursor-pointer"}>
												{/* {this.headerStore.userStatus === 1 ? appstore.getLanguageTrans("Online") : appstore.getLanguageTrans("Offline")} */}
												{appstore.userlivestatus === "online" ? appstore.getLanguageTrans("Online") : appstore.getLanguageTrans("Offline")} 
												
												<img src={imageURLs.downArrowIcon} alt="" className="status-img img-fluid cursor-pointer" />
											</Dropdown.Toggle>

											<Dropdown.Menu x-placement="bottom-centre">
												{dropDownData}
											</Dropdown.Menu>
										</Dropdown>

									</div>

								</div>
							</div>
							{
					   (appstore.isOwner && this.props.appstore.userInfo.accountsmodel.display_buy_now==1) &&
							<div className="d-block d-sm-none pr-10 cart" onClick={() => this.headerStore.openUpgrade(appstore)}>
								<img src={imageURLs.cartMobileIcon} alt="cart" className="img-fluid" />
							</div>
					}
						</div> 
                     {
					   (appstore.isOwner && this.props.appstore.userInfo.accountsmodel.display_buy_now==1) &&
							
						<div className="checkout text-uppercase d-none d-sm-block" onClick={() => this.headerStore.openUpgrade(appstore)}>
							<img src={imageURLs.cartIcon} alt="cart" className="img-fluid" />
							<p className="d-none d-sm-block">{appstore.getLanguageTrans("Buy Now")}</p>
						</div>
	                 }
					</div>
					
					{ this.headerStore.notification_popup &&	
					<ClickOutHandler onClickOut={() => {this.clickouthandler()}}>
					  <ReactTooltip  id='notificationClickme'  clickable={true}
						effect='solid'
						delayHide={500}
						delayShow={500}
						delayUpdate={500}
						place={'bottom'}
						border={true}
						isCapture ={true}
						type={'light'}
						ref= { el => this.tooltip = el}
						>
					
							<NotificationComponent
								store={this.headerStore}
								title="Notifications"
								dismiss="Dismiss"
								read_more="Read More"
								dataForclose = {{ref:this.tooltip , tooltip:ReactTooltip}}
								closeNoti={() => {this.tooltip.tooltipRef = null; ReactTooltip.hide();}}
								appStore={appstore} /> 

					</ReactTooltip>
						</ClickOutHandler>	
	              }
		
{(this.props.appstore.userInfo.accountsmodel.show_welcome == 1 && this.headerStore.showWelcomeCount ==1) &&
			<ClickOutHandler onClickOut={() => this.headerStore.showWelcomeCount = 0}>
					<ReactTooltip id='helpTooltipClick'  clickable={true}
						effect='solid'
						delayHide={500}
						delayShow={500}
						delayUpdate={500}
						place={'bottom'}
						border={true}
						isCapture ={true}
						type={'light'}
						ref= { el => this.tooltip = el}
						>
						<HelpPopupTooltip 
							store={this.headerStore}
							title="Welcome to the live chat operator panel !"
							video_btn="Video Overview"
							close="Start Tour"
							checkSelected={this.headerStore.checkSelected}
							callBack={() => {this.tooltip.tooltipRef = null; ReactTooltip.hide(); this.headerStore.showWelcomeCount =0;}}
							appStore={appstore} />
					</ReactTooltip>	
				</ClickOutHandler>	
	}
				</div> 
				{/* {
					this.headerStore.notification_popup &&
					<NotificationComponent show={this.headerStore.notification_popup}
						store={this.headerStore}
						title="Notifications"
						dismiss="Dismiss"
						read_more="Read More"
						appStore={appstore} />

				} */}

				{/* {
					!this.headerStore.help_popup  &&
					<HelpPopupComponent show={this.headerStore.help_popup}
						store={this.headerStore}
						title="Welcome to the live chat operator panel !"
						video_btn="Video Overview"
						close="Close"
						checkSelected={this.headerStore.checkSelected}
						callBack={() => this.headerStore.help_popup = false}
						closePopup={() => this.headerStore.help_popup = false}
						changeCheck={() => this.headerStore.selectcheck()}
						appStore={appstore} />
				} */}
				{
					this.headerStore.help_tour &&
					<HelpTourComponent show={this.headerStore.help_tour}
						store={this.headerStore}
						body_html={this.headerStore.stepNumber == 0 ? this.headerStore.stepLabel(0) : this.headerStore.stepLabel(this.headerStore.stepNumber)}
						next_btn={self.tourButton()}
						closePopup={() => this.headerStore.help_tour = false}
						callBack={() => this.headerStore.startTour(appstore)}
						appStore={appstore} />

				}

				{this.headerStore.logout &&
					<ConfirmationComponent show={this.headerStore.logout}
						store={this.headerStore}
						title={"Live Chat Dashboard"}
						body_html="<p>Really logout ?</p>"
						logoutCss={"logoutCss"}
						cancel_btn="No"
						save_btn="Yes"
						callBack={(event) => this.confirmLogout()}
						closePopup={() => this.headerStore.logout = false}
						appStore={appstore} />
				}

				
				{
					this.headerStore.isdisabled &&
						<ConfirmationComponent show={this.headerStore.isdisabled}
						store={this.headerStore}
						title="Account Disabled"
						body_html={this.headerStore.bodyMsg}
						singleButton={appstore.isOwner ? false:true}
						cancel_btn={appstore.isOwner ? "Renew Subscription" :"Log in with another email"}
						save_btn={"Log out" }
						closeButtonRequired = {true}
						callBack={() => this.headerStore.closeAccountDisabled(appstore)}
						closePopup={() => this.headerStore.renewSubcription(appstore)}
						appStore = {appstore}/>
				}
				
				{
					this.headerStore.privacyPolicy &&
						<ConfirmationComponent show={this.headerStore.privacyPolicy}
						store={this.headerStore}
						title="Privacy Policy Update"
						body_html="<p>There is an update to our Privacy Policy. Please review and accept HelpOnClick's <a href='https://www.helponclick.com/terms-of-use/' target='_blank'> Terms of Use Agreement</a> and <a href='https://www.helponclick.com/privacy-policy/' target='_blank'>Website Privacy Statement </a> to continue using the service. If you do not agree with the terms, you may request cancellation of the service.</p>"
						cancel_btn="Accept"
						save_btn="Decline" 
						closeButtonRequired = {true}
						callBack={() => appstore.logout()}
						closePopup={() => this.headerStore.confirmPolicyAction(appstore)}
						appStore = {appstore}/>
				}

					{
					 this.headerStore.helpTourGuide && 
						<TourGuide 
						store={this.headerStore}
						appStore = {appstore}
						tourState = {this.headerStore.tourState}
						/>
				
		// <Tour
        //   active={this.headerStore.helpTourGuide}
        //   step={this.state.tourStep}
        //   onNext={(step) => step==2 ? (this.headerStore.helpTourGuide=false,appstore.navigate('/admin/setup/widgets')) : this.setState({tourStep: step})}
        //   onBack={(step) => this.setState({tourStep: step})}
        //   onCancel={() => {appstore.helpTourStarted = false;this.headerStore.helpTourGuide=false}}
        //   steps = {appstore.tourstesps}
		// /> 

					}
				{this.headerStore.helptourstart &&
				<HelpTourImplementStart show={this.headerStore.helptourstart}
							store={this.headerStore}
							title="Welcome to the HelpOnClick Live Chat Dashboard." 
							cancel_btn="Start Tour"
							closePopup={() => {this.headerStore.helptourstart=false;}}
							appStore={appstore} />
							}

				<div>
					<ModalVideo channel='youtube' isOpen={this.headerStore.playVideo} videoId='9pTXiFb_yRo' onClose={() => this.headerStore.playVideo = false} />
				</div>



			</div>
		)
	}
})
export default HeaderComponent;
